// extracted by mini-css-extract-plugin
export default {"customIcon":"HAwmyNXsEjujgjEhW3W8","tooltip":"kE50N7ufGUgaHwxrnfwN"};